import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query'
import { STATUS_BAD_REQUEST, STATUS_NOT_FOUND } from '~/constants/http'

export const getErrorMessage = (
	error: FetchBaseQueryError | SerializedError | undefined
) => {
	// if (Array.isArray((error as any).data.error)) {
	// 	;(error as any).data.error.forEach((el: any) => el.message)
	// } else {
	// 	return (error as any).data.errors
	// }

	switch ((error as any).status) {
		case STATUS_BAD_REQUEST:
			return 'Message_InvalidUsernameOrPassword'
		case STATUS_NOT_FOUND:
			return 'Message_AnErrorOccurredProcessingRequest'
		default:
			return 'Message_AnErrorOccurredProcessingRequest'
	}
}
